import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import NProgress from 'vue-nprogress'
import Snotify from './dialogs'
import VeeValidate, { Validator } from 'vee-validate'

import AuthPlugin from '@/plugins/auth'
import MiscPlugin from '@/plugins/misc'

import ru from 'vee-validate/dist/locale/ru'

Vue.axios = axios
axios.defaults.baseURL = process.env.VUE_APP_API_URL

Vue.use(AuthPlugin, store, router)
Vue.use(NProgress)
Vue.use(MiscPlugin)
Vue.use(VeeValidate, { inject: false })

Validator.localize('ru', ru)
Vue.use(Snotify)

new Vue({
    nprogress: new NProgress({
        parent: '#app',
        showSpinner: false
    }),

    router,
    store,
    render: h => h(App)
}).$mount('#app')
